const globalConst = {
  //serverip: "https://api.a-board.tech/", // local server
   serverip: "https://api.a-board.world/", // main server
  //serverip: "http://13.49.254.247:8080/",
  // serverip: "http://localhost:8080/",
  s3url: "https://pos-stockholm-bucket.s3.eu-north-1.amazonaws.com/"
};
export default globalConst;
